import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQ_TITLE, faqs } from '../data/halloweenKit';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-night-950 py-14 sm:py-20" aria-labelledby="faq-title" data-id="element-65" data-mp="1bmvcau8f62pn">
      <div className="mx-auto max-w-2xl px-5" data-id="element-66" data-mp="1glptxsunhl86">
        <h2 id="faq-title" className="text-center font-display text-[1.8rem] font-semibold leading-tight text-cream-50 sm:text-[2.5rem]" data-id="element-67" data-mp="248xxo6cfkm83">
          {FAQ_TITLE}
        </h2>

        <ul className="mt-9 divide-y divide-night-600 border-y border-night-600" data-id="element-68" data-mp="1uk6ascm88s41">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} data-id="element-69" data-mp="2n8bvx0h70j4e" data-mpi={i}>
                <h3 data-id="element-70" data-mp="2n7aaq36gqg8y">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-5 py-4 text-left" data-id="element-71" data-mp="2n5z5dyxdd0fq">
                    <span className="font-display text-lg leading-snug text-cream-50 sm:text-xl" data-id="element-72" data-mp="1ektv34k9qsxr">{faq.question}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-pumpkin transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-73" data-mp="19u50vhh7fhux" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-74" data-mp="1xhlhvnz0rq6k">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-75" data-mp="1sis5jyvgy57z">
                      <p className="pb-5 text-[15px] leading-relaxed text-body" data-id="element-76" data-mp="23aahzupcyv6z">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}